import React from "react";
import { Select, Skeleton } from "@pankod/refine-antd";
import { useCustom } from "@pankod/refine-core";
import ENV from "utils/env";

interface ShopSelectorProps {
  value: string | null;
  onChange: (value: string | null) => void;
}

export const ShopSelector: React.FC<ShopSelectorProps> = ({
  value,
  onChange,
}) => {
  const { data: response, isFetching } = useCustom({
    url: `${ENV.API_URL}/api/analytics/stats/shops-list`,
    method: "get",
    queryOptions: { retry: 0 },
  });

  const shops: string[] = (response?.data as any) || [];

  if (isFetching) return <Skeleton.Input active style={{ width: 200 }} />;

  return (
    <Select
      value={value || undefined}
      placeholder="Tüm Mağazalar"
      allowClear
      showSearch
      style={{ minWidth: 200 }}
      onChange={(val) => onChange(val || null)}
      optionFilterProp="children"
    >
      {shops.map((code) => (
        <Select.Option key={code} value={code}>
          {code}
        </Select.Option>
      ))}
    </Select>
  );
};
